import React, { useState } from 'react';
import { StepContainer, StepNavigation, ChoiceButtons } from '../components';
import { StepProps, useFormContext, FormData } from '../context';
import { useFormValidation } from '../hooks';

export const Step22_Educacao: React.FC<StepProps> = ({ onNext, onPrevious, isLoading }) => {
  const { data, updateField } = useFormContext();
  const [errors, setErrors] = useState<Record<string, string>>({});

  const scholarshipOptions = [
    { label: 'Fundamental Incompleto', value: 'Fundamental Incompleto' },
    { label: 'Fundamental Completo', value: 'Fundamental Completo' },
    { label: 'Médio Incompleto', value: 'Médio Incompleto' },
    { label: 'Médio Completo', value: 'Médio Completo' },
    { label: 'Superior Incompleto', value: 'Superior Incompleto' },
    { label: 'Superior Completo', value: 'Superior Completo' },
    { label: 'Pós-graduação', value: 'Pós-graduação' },
  ];

  const handleNext = () => {
    const newErrors: Record<string, string> = {};

    if (!data.scholarLevel) newErrors.scholarLevel = 'Grau de escolaridade é obrigatório';

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    onNext({ scholarLevel: data.scholarLevel});
  };

  const handleFieldChange = (fieldName: keyof FormData, value: string) => {
    updateField(fieldName, value);
    if (errors[fieldName]) {
      setErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[fieldName];
        return newErrors;
      });
    }
  };

  return (
    <StepContainer title="Qual seu grau de escolaridade?">
      <div>
        <ChoiceButtons
          options={scholarshipOptions}
          selected={data.scholarLevel || ''}
          onSelect={(value) => handleFieldChange('scholarLevel', value)}
        />
        {errors.scholarLevel && (
          <p className="text-red-600 text-sm mt-2">{errors.scholarLevel}</p>
        )}
      </div>

      <StepNavigation onPrevious={onPrevious} onNext={handleNext} isLoading={isLoading} />
    </StepContainer>
  );
};

export default Step22_Educacao;
